var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jobs",class:("" + (_vm.visible ? '' : 'invisible'))},[_c('Header',{attrs:{"withSearch":true}}),_c('MyProfile')],1)}
var staticRenderFns = []

export { render, staticRenderFns }